import { TemplateDataModel } from "@/component/Template/TemplateDataModel"
import { TableFieldSetColumn } from "../../TableFieldSet/TableFieldSet"
import _ from "lodash"
import { defaultWidthColumn } from "../hooks/useMemoWidthColumns"

import { TableColumnProps } from "antd"
import { FORMAT_STRING } from "../../share/numberFormat"
import { TableModule } from "@/component/common/report/reportConfigModel"
import { ReportConfig } from "@/component/common/report/report"

export const seriesNumberField = '$$series_number$$'
// export const seriesNumberField = "series_number"
export const isSeriesNumber = (field:string)=>seriesNumberField == field

export function getTableColumnsLocalStore(account_id:string){
  const getKey = (tableName:string)=>`tableColumns_${account_id}_${tableName}`
  return {
    save(tableName:string,data:TableFieldSetColumn[]|string){
      let key = getKey(tableName)
      try{
        if(Array.isArray(data)){
          data = data.map(item=>{
            return {
              width: Math.ceil(Number(item.width)),
              show: item.show,
              dataIndex: item.dataIndex,
            }
          })
        }
        localStorage.setItem(key,JSON.stringify(data)) 
      }catch(e){
        return {}
      }
    },
    get(tableName:string){
      let key = getKey(tableName)
      try{
        let data = localStorage.getItem(key) 
        if(!data){
          return undefined
        }
        return JSON.parse(data)
      }catch(e){
        return undefined
      }
    }
  }
}
export  const pageInfoStore =(()=>{
  let key = 'dhbPageSize'
  return {
    save:(pageSize:string)=>{
      localStorage.setItem(key,pageSize) 
    },
    get:()=>{
      return localStorage.getItem(key)
    }
  }
})();


const textAlignMap:{[x:number]:TableColumnProps<{}>['align']} = {
  1:'left',
  2:'center',
  3: "right"
}


export const mergeColumns = (template: TemplateDataModel, options:{report_name:string,accounts_id:string,showSeriesNumber?:boolean,defaultDisplayFields?:string[]} ):TableFieldSetColumn[]=>{
  const { report_name,accounts_id ,showSeriesNumber,defaultDisplayFields = []} = options
  let templateFields = template.fields  || [];
  let templateColumnsObj = _.keyBy(templateFields,'code')
  const tableColumnsLocalStore = getTableColumnsLocalStore(accounts_id)
  let localColumns:TableFieldSetColumn[] = tableColumnsLocalStore.get(report_name);
  let convertColumn = (templateFiled: Required<TemplateDataModel>['fields'][0])=>{
    let isShow = !defaultDisplayFields.length ||  defaultDisplayFields.includes(templateFiled.code)
    let width = templateFiled.attribute?.width || 130
    let isEllipsis = templateFiled.valueType == FORMAT_STRING
    let isSerial = !!templateFiled.attribute?.autoIncrement
    if(isSerial){
      isShow = true
    }
      let column:TableFieldSetColumn =  {
        dataIndex: templateFiled.code,
        title: templateFiled.title,
        switchFixed: 'F',
        switchShow:'T',
        show: isShow ? 'T' : 'F',
        ellipsis: isEllipsis,
        align: textAlignMap[templateFiled.attribute?.horizontalAlign],
        width: Math.ceil(width/0.15), 
        isSerial,
      }
      return column
  }
  if(!localColumns){
    let columns = templateFields.map(item=>{
      return convertColumn(item)
    })
    // if(showSeriesNumber){
    //   columns.unshift({
    //     dataIndex: seriesNumberField,
    //     title: ' ',
    //     switchFixed: 'F',
    //     switchShow:'T',
    //     show: 'T',
    //     width: 100, 
    //   })
    // }
    return columns
  }else{
    let localColumnsObj = _.keyBy(localColumns,'dataIndex');
  
    const tableColumns:TableFieldSetColumn[] = []
    localColumns.forEach(item=>{
      let templateColumn = templateColumnsObj[item.dataIndex]
      // if(templateColumn){
      //   item.title = templateColumn.title
      //   item.width = Math.max(Number(item.width),defaultWidthColumn)
      // }
      if(templateColumn){
        let column =  convertColumn(templateColumn)
        column.width = item.width
        column.show = item.show
        tableColumns.push(column)
      }
    })
    templateFields.forEach(item=>{
      if(!localColumnsObj[item.code]){
        tableColumns.push(convertColumn(item))
      }
    })
    return tableColumns
  }
  // return localColumns
}

export const getTransmferFields = (configData?:ReportConfig)=>{
  let tableModule  = configData?.config.report_config.modules.find(item=>item.type == 'table') as TableModule
  if(tableModule && tableModule.transformer_fields){
    return JSON.stringify(tableModule.transformer_fields)
  }
  return ''
}